import React from 'react';

import qrImage from '../../assets/images/qr2.png';

import classes from './outro.module.scss';

import RepeatSVG from '@/assets/svg/repeat.svg';
import BulletSVG from '@/assets/svg/bullet.svg';
import Image from '@/components/UI/Image/Image';
import { useStorage } from '@/models/Storage';
import Button from '@/components/UI/Button/Button';
import { analytics, prepareUrl } from '@/utils/analytics';

export const Outro = () => {
    const { setStage, stage } = useStorage();

    return stage !== 'outro' ? null : (
        <div className={classes.outro}>
            <div className={classes.content}>
                <span className={classes.title}>Ура! Вы все разгадали</span>
                <div className={classes.text}>
                    <p>
                        У нас закончились моменты. Но в&nbsp;приложении Ozon их&nbsp;намного больше.
                    </p>
                    <p className={classes.shifted}>
                        <BulletSVG />
                        Если вы любите забавные и&nbsp;полезные видео, создавайте страницу
                        в&nbsp;Ozon Моментах и&nbsp;смотрите короткие ролики в&nbsp;бесконечной
                        ленте с&nbsp;рекомендациями, а&nbsp;также — подписывайтесь
                        на&nbsp;пользователей и&nbsp;любимых блогеров. Бонусом — прямые эфиры
                        с&nbsp;эксклюзивными скидками и&nbsp;конкурсами.
                    </p>
                    <p className={classes.shifted}>
                        <BulletSVG />
                        Если вы сами снимаете видео, вас ждет многомиллионная аудитория Ozon
                        и&nbsp;доступная программа монетизации контента. Кроме того,
                        на&nbsp;маркетплейсе много продавцов, которые захотят продвигать товары
                        в&nbsp;Моментах, делиться скидками и&nbsp;устраивать розыгрыши
                        для&nbsp;ваших подписчиков.
                    </p>
                </div>
                <div className={classes.lower}>
                    <div className={classes.qr}>
                        <Image src={qrImage} />
                        <span>Просканируйте QR-код, чтобы открыть Моменты в приложении Ozon.</span>
                    </div>
                    <Button
                        text={'В Моменты'}
                        link={prepareUrl(
                            'https://ads.adfox.ru/260477/goLink?p1=cnpjl&p2=frfe&p5=mxwvo&pr=%random% ',
                        )}
                        colorScheme={'secondary'}
                    />
                </div>

                <div
                    className={classes.repeat}
                    onClick={() => {
                        analytics(
                            'https://ads.adfox.ru/260477/getCode?p1=cnpjl&p2=frfe&pfc=esnmm&pfb=mxwwg&pr=%random%&ptrc=b',
                        );
                        setStage('intro');
                    }}
                >
                    <span>Ещё раз</span>
                    <RepeatSVG />
                </div>
            </div>
        </div>
    );
};
